// extracted by css-extract-rspack-plugin
export default {"root":"root-iRenne","freeBox":"freeBox-ZRWs0b","svg":"svg-Wfqp8N","rootreadOnly":"rootreadOnly-DcmEwp","svgreadOnly":"svgreadOnly-_b6ApL"};